import { createContext } from "react";

const DailyContext = createContext(undefined as any);

export default DailyContext;
